"use strict";

/*
 * Opens the Cookiebot consent dialog from an ordinary link.
 *
 * Editors cannot use href="javascript:Cookiebot.show()" in a WYSIWYG, because both TinyMCE
 * and Pimcore's HtmlSanitizer strip script URLs. Instead they link to the marker anchor
 * '#cookie-settings', which passes the sanitizer untouched.
 */
const MARKER_SELECTOR = 'a[href="#cookie-settings"], a[href$="#cookie-settings"], .js-cookie-settings';

export function initInScope($scope) {
    $scope.find(MARKER_SELECTOR).on('click', function (e) {
        // The consent script tag carries id="Cookiebot", so window.Cookiebot is that element
        // until uc.js has replaced it with the API object - check for show() and not the global.
        if (typeof window.Cookiebot === 'undefined' || typeof window.Cookiebot.show !== 'function') {
            return;
        }

        e.preventDefault();
        window.Cookiebot.show();
    });
}
